/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 935ffd335bc53337050549de2b401b55a2eef628d53f804744a978f0f88db128
 */
import { css } from 'styled-components'

export default css`
  display: inline-flex;
  position: relative;

  .menu {
    position: absolute;
    z-index: 1;
  }

  .menu.bottom-start {
    left: 0;
    top: 100%;
  }

  .menu.bottom-end {
    right: 0;
    top: 100%;
  }

  .menu.top-start {
    bottom: 100%;
    left: 0;
  }

  .menu.top-end {
    bottom: 100%;
    right: 0;
  }
`
